<app-modal-frame [headerText]="CONST.HEADER" (emitExit)="onClose($event)">
  <div [formGroup]="transferUldForm" class="transfer-uld-container">
    <h3 class="title">{{ CONST.ENTER_INFO }}</h3>

    <ion-row>
      <ion-col size="auto" class="custom-col">
        <div class="md-control equipment-number-container">
          <app-form-input-field
            [label]="CONST.EQUIPMENT_NUMBER"
            [formControlName]="IDS.EQUIPMENT_NUMBER"
            [placeholder]="CONST.NUMBER_PLACEHOLDER"
            [maxLength]="11"
            [regexType]="SpecialCharacters.ALPHABET_NUMBER_NO_SPACE"
          ></app-form-input-field>
        </div>
      </ion-col>
      <ion-col size="auto">
        <div class="md-control equipment-type-select">
          <app-form-select
            [label]="CONST.EQUIPMENT_TYPE"
            [options]="TYPE_OPTIONS"
            [formControlName]="IDS.EQUIPMENT_TYPE"
            [required]="false"
            [placeholder]="CONST.TYPE_PLACEHOLDER"
            [isAppendToBody]="true"
          >
          </app-form-select>
        </div>
      </ion-col>
    </ion-row>
    <div class="footer">
      <ion-button class="back-btn footer-btn" fill="outline" (click)="cancel()">
        {{ CONST.CANCEL }}
      </ion-button>
      <ion-button
        class="transfer-btn footer-btn"
        [disabled]="transferUldForm.invalid"
        (click)="transfer()"
      >
        {{ CONST.TRANSFER }}
      </ion-button>
    </div>
  </div>
</app-modal-frame>
